import { jsx as _jsx } from "react/jsx-runtime";
import { ChakraProvider } from "@chakra-ui/react";
import { initializeIcons } from "@fluentui/react";
import ThemeManager from "../ThemeManager";
import '../../index.css';
initializeIcons();
var CoreUiProvider = function (_a) {
    var children = _a.children;
    return (_jsx(ThemeManager, { children: _jsx(ChakraProvider, { children: children }) }));
};
export default CoreUiProvider;
